import React, { FC } from "react";
import "./CloseVideoIcon.scss";

type CloseVideoIconProps = {
  onClickClose: Function;
  isFullScreen: boolean;
};
const CloseVideoIcon: FC<CloseVideoIconProps> = ({
  onClickClose,
  isFullScreen,
}) => {
  return (
    <span
      className={`close-video-icon cursor-click ${
        isFullScreen ? "is-fullscreen" : ""
      }`}
      onClick={() => onClickClose()}
      tabIndex={0}
    />
  );
};

export default CloseVideoIcon;
